import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export class SetAvstandNarmasteIndustriJusteratCommand extends BasicCommand<SetAvstandNarmasteIndustriJusteratCommand> {
    get primaryKey(): IPrimaryKey<SetAvstandNarmasteIndustriJusteratCommand> {
        return {
            arbetsorderHandelssortimentId: this.arbetsorderHandelssortimentId
        };
    }
    arbetsorderHandelssortimentId: number;
    avstandNarmasteIndustriJusterat?: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Arbetsorder";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "SetAvstandNarmasteIndustriJusteratCommand";
    constructor(init: (instance: SetAvstandNarmasteIndustriJusteratCommand) => void) {
        super(SetAvstandNarmasteIndustriJusteratCommand.$type, SetAvstandNarmasteIndustriJusteratCommand.$groupKey, CommandType.Replace);
        init(this);
    }
}
